import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { ReceiptAlertsProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReceiptAlerts: React.FC<ReceiptAlertsProps> = (props) => {
  const { hasMissingPaymentDetails } = props;

  const { enqueueMessage } = useFloatingMessages();

  React.useEffect(() => {
    if (hasMissingPaymentDetails) {
      enqueueMessage(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.ReceiptPaymentInfoMissing),
        StyleEnums.DisplayType.Info
      );
    }
  }, [hasMissingPaymentDetails]);

  return <></>;
};

export default ReceiptAlerts;
